import React, { useContext, useEffect, useRef } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import Regex from "../../../Utilities/Regex";
import { agentWalletHistoryAction } from "../../../Redux/Action/AgentAction";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { AgentWalletHistoryContext } from "../AgentWalletHistoryComponent";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import { TiDelete } from 'react-icons/ti';
import { RxCross2 } from 'react-icons/rx';

function WalletHistoryForm(props) {

    //ref
    const btnRef = useRef()
    // Hook
    const dispatch = useDispatch()

    // Context
    const {
        setAgentWalletHistory
    } = useContext(AgentWalletHistoryContext)

    useEffect(() => {
        const payload = {
            data: { row_count: 100 },
            reset,
            btnRef,
            setAgentWalletHistory
        }
        dispatch(agentWalletHistoryAction(payload))
    }, [])


    // hook form
    const { register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();

    const onSubmit = data => {
        //console.log(data)
        const payload = {
            data,
            reset,
            btnRef,
            setAgentWalletHistory
        }
        dispatch(agentWalletHistoryAction(payload))


    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {/*Agent full_name field*/}
                <Row>
                    {true == false ? <Col md={5} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    defaultValue={100}
                                    type="text"
                                    placeholder="Number of Row"
                                    {...register("row_count", {
                                        required: true,
                                        pattern: Regex.numeric()
                                    })}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("row_count")
                                    document.getElementById("walletSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.row_count && <span className="text-danger">
                                {errors.row_count.type === "required" && "Please Give Number of Row"}
                                {errors.row_count.type === "pattern" && "Please Give Valid Number of Row"}
                            </span>}
                        </Form.Group>
                    </Col> : ""}
                    <Col md={5} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Collector Id"
                                    {...register("agent_id", {
                                        required: false,
                                        pattern: Regex.numeric()
                                    })}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("agent_id")
                                    document.getElementById("walletSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.agent_id && <span className="text-danger">
                                {errors.agent_id.type === "required" && "Please Give Collector Id"}
                                {errors.agent_id.type === "pattern" && "Please Give Valid Collector Id"}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={2} sm={12}>
                        <Button id="walletSubmitButton" ref={btnRef} variant="primary" type="submit" className="submit">
                            Submit
                            <ButtonLoader />
                        </Button>
                    </Col>
                </Row>

            </form>
        </>
    );
}

export default WalletHistoryForm;